// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3Br_o","panel":"styles_panel__dGFSO","image":"styles_image__xdxze","baseStyles":"styles_baseStyles__cTqbZ"};